import { FormattedMessage } from 'react-intl';
import iconMetroPin from '/assets/images/icon-metro-pin.svg';
import { FormCheck } from 'react-bootstrap';
import FormCheckInput from 'react-bootstrap/esm/FormCheckInput';
import FormCheckLabel from 'react-bootstrap/esm/FormCheckLabel';

const PinUnpinButton = ({
  isPinned,
  handleTogglePin,
  formId,
}) => {

  return (
    <div>
      <FormCheck
        type='checkbox'
        id={formId+"pinned_checkbox"}
      >
        <FormCheckInput 
          type='checkbox'
          checked={isPinned}
          onChange={handleTogglePin}
          style={{float: 'initial'}}
        />
        <FormCheckLabel>
          <FormattedMessage id="pinnedPin" />
        </FormCheckLabel>
      </FormCheck>
    </div>
  );
}

export default PinUnpinButton;